export default (store) => {
  const ability = store.getters.ability;

  ability.update([]);

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case "profile/SET_PROFILE":
        ability.update((mutation.payload && mutation.payload.rules) || []);
        break;
      case "auth/SET_TOKEN":
        if (!mutation.payload) {
          ability.update([]);
        }
    }
  });
};
